import { BreadcrumbService } from 'src/app/angularJS/services/breadcrumbs/breadcrumb.service';

/**
 * A controller that shows a timeline for a selected Fulfilment Request
 */
export class FulfilmentRequestTimelineController {
  public static $inject = ['breadcrumbService', '$stateParams', 'fulfilmentRequest', 'fulfilmentStatuses'];

  public timeline: InterACT.Interfaces.FulfilmentRequests.FulfilmentRequest[] = [];
  public positiveStatuses;
  public negativeStatuses;
  public neutralStatuses;

  constructor(
    private breadcrumbService: BreadcrumbService,
    private $stateParams: ng.ui.IStateParamsService,
    private fulfilmentRequest: InterACT.Interfaces.FulfilmentRequests.FulfilmentRequestResponse,
    private fulfilmentStatuses: InterACT.Interfaces.IFulfilmentStatuses) {
    this.activate();
  }

  /**
   * Determines the time difference between two events
   *
   * @param event The current event that we wish to calculate the time difference for in relation to the previous occurring event
   * @param showFirstToLastTimeDifference A flag that indicates if we wish to return a time difference from start to last
   */
  public determineTimeDifference = (event: InterACT.Interfaces.FulfilmentRequests.FulfilmentRequest, showFirstToLastTimeDifference: boolean) => {
    let timeString;

    if (showFirstToLastTimeDifference) {
      let diff = <any>moment((<any>this.timeline[0]).created).diff(moment((<any>this.timeline[this.timeline.length - 1]).created));

      timeString = this.createTimeDifferenceString(diff);
    } else {
      let index = this.timeline.indexOf(event);

      if (this.timeline[index + 1]) {
        let diff = <any>moment((<any>this.timeline[index]).created).diff(moment((<any>this.timeline[index + 1]).created));

        timeString = this.createTimeDifferenceString(diff);
      }
    }

    return timeString;
  }

  private createTimeDifferenceString = (diff) => {
    return `${this.pluralise(moment.duration(diff).days(), 'day')}, ${this.pluralise(moment.duration(diff).hours(), 'hour')}, ${this.pluralise(Math.ceil(moment.duration(diff).minutes()), 'minute')}, ${this.pluralise(Math.ceil(moment.duration(diff).seconds()), 'second')}`;
  }

  /**
   * Determines if we should pluralise a time string
   *
   * @param time The time we wish to check against
   * @param unit A unit of time
   */
  private pluralise = (time: number, unit: string) => {
    if (time !== 1) {
      return `${time} ${unit}s`;
    } else {
      return `${time} ${unit}`;
    }
  }

  /**
   * Determines if a status is positive
   *
   * @param status The status of the event that we wish to perform the check on
   */
  public isPositiveStatus = (status: string) => {
    return _.includes(this.positiveStatuses, status);
  }

  /**
   * Determines if a status is invalid
   *
   * @param status The status of the event that we wish to perform the check on
   */
  public isInvalidStatus = (status: string) => {
    return _.includes(this.negativeStatuses, status);
  }

  /**
   * Determines if a status is neutral
   *
   * @param status The status of the event that we wish to perform the check on
   */
  public isNeutralStatus = (status: string) => {
    return _.includes(this.neutralStatuses, status);
  }

  /**
   * Gets invoked upon instantiation
   */
  private activate = () => {
    this.positiveStatuses = this.fulfilmentStatuses.positive;
    this.negativeStatuses = this.fulfilmentStatuses.negative;
    this.neutralStatuses = this.fulfilmentStatuses.neutral;

    this.fulfilmentRequest.notifications.forEach((notification: any) => {
      this.timeline.push(notification);
    });

    this.timeline.reverse();

    this.breadcrumbService.setBreadcrumbs([{
      name: 'FULFILMENT',
      sref: 'fulfilment'
    }, {
      name: 'FULFILMENT_REQUESTS',
      sref: 'fulfilment-requests',
      params: {
        queryName: this.$stateParams.queryName,
        filterQuery: this.$stateParams.filterQuery
      }
    }, {
      name: this.$stateParams.externalId,
      sref: 'fulfilment-requests-details'
    }])
  }
}
